import React from 'react';
import { Chip, alpha } from '@mui/material';
import { STATUS, STATUS_CASH } from '../../utils/derivativeReconConstants';

export default function StatusChip({ status, cash = false }) {
  const map = cash ? STATUS_CASH : STATUS;
  const s = map[status];
  if (!s) return null;
  return (
    <Chip
      size="small"
      label={s.label}
      sx={{
        bgcolor: alpha(s.color, 0.18),
        color: s.color,
        border: `1px solid ${alpha(s.color, 0.5)}`,
        fontWeight: 600,
        fontSize: 11,
        height: 22,
      }}
    />
  );
}
